'use strict';

if (!Symbol.species) {
    Symbol.species = Symbol.for('@@species');
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-matrix/src/symbol-species.js
// module id = 35
// module chunks = 0